module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_8003.c288abe7.png";